export const getters = {
    approvers(state) {
      return state.approvers;
    },
  };
